import React, {Component} from 'react'
import StarRatingComponent from 'react-star-rating-component'
import {Link} from 'react-router-dom'
import * as UrlHelpers from '../../helpers/urlHelpers'

class ProblemStub extends Component {
  render() {
    let {problem, setActiveProblem, selected} = this.props
    let ascents = problem.ascents
    let numAscents = ascents.length
    let display = this.props.display
    let condensed = display === 'condensed'
    return (
      (condensed && [
        <Link
          key="1"
          className="no-decoration"
          to={UrlHelpers.problemPath(problem)}>
          <div className="white" style={{padding: '5px 5px'}}>
            {problem.name}, {problem.userName}, {problem.grade.vgrade}
          </div>
        </Link>,
        <hr key="2" />,
      ]) || (
        <div
          className={selected ? 'selected' : ''}
          onClick={() => {
            setActiveProblem(problem)
          }}
          style={{padding: '15px 15px'}}>
          <h2 style={{marginTop: 5, marginBottom: 0}}>{problem.name}</h2>
          <h3 style={{marginTop: 5, marginBottom: 0}}>{problem.userName}</h3>
          <div>
            {problem.timestamp && problem.timestamp.toDate().toString()}
          </div>
          <StarRatingComponent
            name="boulder-rating"
            editing={false}
            starCount={5}
            emptyStarColor="#aaaaaa"
            value={problem.rating}
          />
          <div>
            {problem.grade.vgrade}/font {problem.grade.font}
          </div>
          {problem.feet && <div>{problem.feet.text}</div>}
          <div>{ascents.length + ' ascent' + (numAscents > 1 ? 's' : '')}</div>
        </div>
      )
    )
  }
}

export default ProblemStub



// WEBPACK FOOTER //
// ./src/components/problems/ProblemStub.jsx